<template>
  <div id="SharedDoc" class="fullheightExceptTag">
    <el-container style="height: 100%; border: 1px solid #eee">
      <fe-aside-tree
        type-key="OA_SHARE_DOCUMENT"
        @node-click="handleNodeClick"
        @check="check"
        :can-edit="true"
        :can-add="true"
        :can-del="true"
        :search-url="'${business}/oa/oa_shared_document/query'"
      />
      <el-main>
        <fe-table
          @load="loadData"
          :data="budget_manager"
          :pageResult="pageResult"
          :selection="true"
          quick-search-props="f_document_no,f_document_name"
          :show-export="false"
          :show-custom-column="true"
          ref="ecoTable"
        >
          <template v-slot:toolbar>
            <el-button-group>
              <fe-delete-button url="${business}/oa/oa_shared_document/" :htTable="$refs.ecoTable">删除 </fe-delete-button>
            </el-button-group>
          </template>
          <template v-slot:search>
            <fe-table-search-panel :divide="3" :label-width="100">
              <fe-table-search-field label="共享范围" prop="f_share_range" />
            </fe-table-search-panel>
          </template>
          <template>
            <fe-table-column type="index" width="50" align="center" label="序号" />
            <fe-table-column prop="f_document_no" label="文档编号" :sortable="true" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click="showDialog(scope.row.id)">
                  {{ scope.row.f_document_no }}
                </el-link>
              </template>
            </fe-table-column>
            <fe-table-column prop="f_document_name" label="文档名称" :sortable="true" :show-overflow-tooltip="true"> </fe-table-column>
            <fe-table-column prop="f_type" label="文档分类" :sortable="true" :show-overflow-tooltip="true" :formatter="attrFormat"> </fe-table-column>

            <fe-table-column prop="f_share_range" label="共享范围" :sortable="true" :show-overflow-tooltip="true"> </fe-table-column>
            <fe-table-column prop="f_create_time" label="创建时间" :sortable="true" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.f_create_time | dateYMDFormat }}
              </template>
            </fe-table-column>
            <fe-table-column prop="f_create_user" label="创建人" :sortable="true" :show-overflow-tooltip="true"> </fe-table-column>
          </template>
        </fe-table>
      </el-main>
    </el-container>
    <el-dialog
      :close-on-click-modal="false"
      width="70%"
      title="文档"
      class="sp-manager__dialog"
      :visible="dialogVisible"
      :before-close="beforeCloseDialog"
      @dialogclose="beforeCloseDialog"
      @load="loadData"
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">文档</span>
      </div>
      <form v-if="html" data-vv-scope="custom-form">
        <online-form
          class="custom-form"
          v-if="dialogVisible"
          :html="html"
          :model="model"
          :data="data"
          :permission="permission"
          :isView="isView"
          :url="addurl"
          :saveMethod="saveMethod"
          :isEdit="isEdit"
          :isHideBtn="true"
          ref="onlineForm"
        />
      </form>
    </el-dialog>
  </div>
</template>
<script>
import OnlineForm from '@/views/system/components/OnlineForm.vue'
import form from '@/api/formContent.js'
import utils from '@/utils.js'
const FeAsideTree = () => import('@/views/system/components/FeAsideTree.vue')
export default {
  components: {
    FeAsideTree,
    OnlineForm
  },
  data() {
    return {
      dialogVisible: false,
      addurl: '${business}/oa/oa_shared_document/',
      initData: {},
      budget_manager: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      model: {},
      html: null,
      data: {},
      permission: null,
      isView: true,
      isEdit: false,
      saveMethod: 'POST',
      formType: '',
      bpmForm: {
        formKey: '',
        bos: '',
        desc: ''
      },
      typeIdQuery: null,
      formList: [],
      attrDicData: []
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    handleNodeClick(node) {
      if (node.typeKey == 'OA_SHARE_DOCUMENT') {
        this.typeIdQuery = null
        this.formType = ''
      } else {
        this.bpmForm.typeName = node.name
        this.formType = node.typeKey
        this.typeIdQuery = {
          property: 'type',
          value: node.typeKey,
          group: 'type',
          operation: 'EQUAL',
          relation: 'AND'
        }
      }
      this.$refs.ecoTable.load()
    },
    check(data, checkObj) {
      if (checkObj.checkedKeys.length == 0) {
        this.typeIdQuery = null
      } else {
        this.typeIdQuery = {
          property: 'type',
          value: checkObj.checkedKeys.join(','),
          group: 'type',
          operation: 'IN',
          relation: 'AND'
        }
      }
      this.$refs.ecoTable.load()
    },
    showDialog: function (id, noBtn) {
      this.html = null
      this.model = {}
      this.data = {}
      this.permission = null
      if (noBtn) {
        this.isHideBtn = true
      } else {
        this.isHideBtn = false
      }
      this.$http.get('${form}/form/form/v1/getFormByKey?key=gxwd').then((resp) => {
        var $ = require('jquery')
        let _me = this
        let handlerJs = function (rep) {
          const currentUser = _me.$store.state.login.currentUser

          let data = _me.data
          eval(rep.diyJs)
        }

        let handler = function (rep) {
          form.preview(rep.bpmForm.id, handlerJs)
          _me.data = rep.data
          Object.assign(_me.initData, rep.data.oa_shared_document)
          if (id) {
            _me.isEdit = true
            _me.saveMethod = 'PUT'
            _me.$http.get('${business}/oa/oa_shared_document/' + id).then(
              (resp) => {
                const a = _me.data.oa_shared_document
                const b = resp.data
                const newObj = {}
                Object.assign(newObj, a, b)
                _me.data.oa_shared_document = newObj
                if (_me.data.oa_shared_document.is_share == 0) {
                  _me.data.oa_shared_document.share_to = null
                  _me.data.oa_shared_document.user_share_range = ''
                  _me.data.oa_shared_document.dept_share_range = ''

                  _me.data.oa_shared_document.user_id_share_range = ''
                  _me.data.oa_shared_document.dept_id_share_range = ''
                  _me.data.oa_shared_document.sub_oa_shared_document_detail = []
                } else {
                  let userIdArr = []
                  let userNameArr = []
                  switch (_me.data.oa_shared_document.share_to) {
                    case '1':
                      _me.data.oa_shared_document.user_id_share_range = ''
                      _me.data.oa_shared_document.user_share_range = ''
                      _me.data.oa_shared_document.dept_share_range = ''
                      _me.data.oa_shared_document.dept_id_share_range = ''
                      if (_me.data.oa_shared_document.share_range && _me.data.oa_shared_document.sub_oa_shared_document_detail.length) {
                        _me.data.oa_shared_document.sub_oa_shared_document_detail.forEach((e) => {
                          userIdArr.push(e.user_id)
                          userNameArr.push(e.user_name)
                        })
                        _me.data.oa_shared_document.user_id_share_range = userIdArr.join(',')
                        _me.data.oa_shared_document.user_share_range = userNameArr.join(',')
                        _me.data.oa_shared_document.share_range = ''
                        _me.data.oa_shared_document.share_range = userNameArr.join(',')
                      }

                      break
                    case '2':
                      _me.data.oa_shared_document.user_share_range = ''
                      _me.data.oa_shared_document.user_id_share_range = ''
                      _me.data.oa_shared_document.dept_share_range = ''
                      _me.data.oa_shared_document.dept_id_share_range = ''
                      if (_me.data.oa_shared_document.share_range && _me.data.oa_shared_document.sub_oa_shared_document_detail.length) {
                        _me.data.oa_shared_document.sub_oa_shared_document_detail.forEach((e) => {
                          userIdArr.push(e.dept_id)
                          userNameArr.push(e.dept_name)
                        })
                        _me.data.oa_shared_document.dept_id_share_range = userIdArr.join(',')
                        _me.data.oa_shared_document.dept_share_range = userNameArr.join(',')
                        _me.data.oa_shared_document.share_range = ''
                        _me.data.oa_shared_document.share_range = userNameArr.join(',')
                      }

                      break
                    case '3':
                      _me.data.oa_shared_document.share_range = ''
                      _me.data.oa_shared_document.user_share_range = ''
                      _me.data.oa_shared_document.dept_share_range = ''
                      _me.data.oa_shared_document.user_id_share_range = ''
                      _me.data.oa_shared_document.dept_id_share_range = ''
                      _me.data.oa_shared_document.sub_oa_shared_document_detail = []
                      break
                  }
                }
                _me.model = _me.data.oa_shared_document
              },
              (error) => {
                reject(error)
              }
            )
          }
          _me.model = _me.data.oa_shared_document
          if (rep.permission) {
            _me.permission = rep.permission
          }
          _me.html = rep.bpmForm.formHtml
        }
        if (resp.data.id) {
          form.previewDesignVue(resp.data.id, handler)
        }
      })
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    beforeCloseDialog() {
      this.dialogVisible = false
    },
    calleArr(array) {
      if (array && array.length > 0) {
        array.forEach((ele) => {
          if (ele.children && ele.children.length > 0) {
            const obj = {
              name: ele.name,
              typeKey: ele.typeKey
            }
            this.attrDicData.push(obj)
            this.calleArr(ele.children)
          } else {
            const obj = {
              name: ele.name,
              typeKey: ele.typeKey
            }
            this.attrDicData.push(obj)
          }
        })
      }
    },
    attrFormat(row) {
      if (this.attrDicData && this.attrDicData.length > 0) {
        return this.attrDicData.map((item) => {
          if (row.f_type == item.typeKey) {
            return item.name
          }
        })
      }
    },

    loadData(param, cb) {
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        }
        sessionStorage.setItem('loadJSON', JSON.stringify(obj))
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem('loadJSON'))
        param = session.param
        cb = session.cb
      }
      let _param = {}
      _param = { ..._param, ...param }
      if (this.typeIdQuery) {
        if (_param.querys && _param.querys.length > 0) {
          _param.querys.push(this.typeIdQuery)
        } else {
          _param.querys = []
          _param.querys.push(this.typeIdQuery)
        }
      }

      this.$http
        .post('${business}/oa/oa_shared_document/query', _param)
        .then(
          (resp) => {
            let response = resp.data
            if (response.rows && response.rows.length > 0) {
              response.rows.forEach((val) => {
                val.f_share_range = val.share_range
                val.f_create_user = val.create_user
                val.f_create_time = val.create_time
                val.f_document_name = val.document_name
                val.f_document_no = val.document_no
                val.f_type = val.type
              })
            }
            this.pageResult = {
              page: Number(response.page),
              pageSize: Number(response.pageSize),
              total: Number(response.total)
            }
            setTimeout(() => {
              if (sessionStorage.getItem('tree')) {
                const treeData = JSON.parse(sessionStorage.getItem('tree'))
                this.attrDicData = []
                this.calleArr(treeData)
              }
              this.budget_manager = response.rows
            }, 500)
          },
          (error) => {
            reject(error)
          }
        )
        .finally(() => cb())
    }
  }
}
</script>

<style lang="scss">
#SharedDoc {
  padding: 20px 10px;
  .sp-manager__dialog /deep/ > .el-dialog > .el-dialog__body {
    height: calc(100% - 170px);
  }

  .dialog-header-title {
    padding-bottom: 10px;
  }

  .dialog-header-title > span {
    border-left: 3px solid #2761ff;
    font-weight: 700;
    font-size: 14px;
    padding-left: 10px;
    color: #666;
  }
  .addBtnForTable {
    height: 24px;
  }

  .el-dialog__body {
    overflow-x: scroll;
  }
}
</style>
